import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/7_4.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Praca u szewca"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p20,
            }}
            content={
                <div>
                    <ul>
                        <li>Ciekawe! – odpowiadasz kurtuazyjnie kantorowi, który najwidoczniej lubi sobie pogawędzić. – A co do pracy – wie pan, gdzie szukać jakiegoś zarobku?</li>
                        <li>Ach, praca, no tak! – otrząsa się kantor. – U nowego szewca coś podobno było. Nie znam go za dobrze. Poprzedni – Łakomiak – to była marka! Ten otworzył niedawno. A warsztat ma niedaleko – kantor pokazuje w stronę miasteczka. – Dziś go pewnie nie zastaniesz, bo widziałem, jak wyjeżdżał z rana, ale jutro już powinien być. </li>
                    </ul>
                </div>
            }
        />

    );
}